/** biome-ignore-all lint/suspicious/noConsole: we want to log localStorage operations  if they fail */

import type { ServerReceivedMapDeployments } from './models/mapDeployments'

export function saveToLocalStorage(data: unknown) {
	if (typeof window !== 'undefined') {
		try {
			// remove any key to clean up old data
			localStorage.removeItem('mapDeployments')
			localStorage.setItem(
				'ogw_marketview-deployments',
				JSON.stringify(data)
			)
			console.log('saved mapDeployments to localStorage')
		} catch (e) {
			console.warn('failed to save mapDeployments to localStorage', e)
		}
	}
}

export function getMapDeploymentsFromLocalStorage() {
	if (typeof window !== 'undefined') {
		localStorage.removeItem('mapDeployments')
		const localData = localStorage.getItem('ogw_marketview-deployments')
		if (localData) {
			try {
				// remove any key to clean up old data
				const parsed = JSON.parse(
					localData
				) as ServerReceivedMapDeployments

				return { ...parsed, version: parsed.version ?? '0.0' }
			} catch (e) {
				console.warn(
					'failed to parse mapDeployments from localStorage',
					e
				)
			}
		}
		console.warn('No data in localStorage')
	}
	return null
}
